import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {PropertyListComponent} from './components/property-list/property-list.component';


const routes: Routes = [
  { path: 'properties', component: PropertyListComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
